import React from 'react';

export const SharedResultBanner: React.FC = () => {
  const [isVisible, setIsVisible] = React.useState(true);

  if (!isVisible) return null;

  return (
    <div style={{
      backgroundColor: '#f97316',
      color: 'white',
      textAlign: 'center',
      padding: '10px 20px',
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      maxWidth: '300px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      zIndex: 1000,
      animation: 'slideIn 0.5s ease-out',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    }}>
      <div style={{ flex: 1 }}>
        <p style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>
          Want to create your own roast?
        </p>
        <p style={{ margin: 0, fontSize: '14px' }}>
          Sign up for free to roast your own listings!
        </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <button
          onClick={() => window.location.href = '/'}
          style={{
            backgroundColor: 'white',
            color: '#f97316',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold',
            flexShrink: 0,
            transition: 'transform 0.2s',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          Try Now
        </button>
        <button
          onClick={() => setIsVisible(false)}
          style={{
            backgroundColor: 'transparent',
            color: 'white',
            border: 'none',
            padding: '4px 8px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px',
            opacity: 0.8,
            transition: 'opacity 0.2s',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.opacity = '1';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.opacity = '0.8';
          }}
        >
          Dismiss
        </button>
      </div>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateY(100px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};
